var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), !_vm.isLoading ? _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.marketBannerImage.icon.fileUrl,
      "alt": "Healthcare Market Banner"
    }
  })]), _c('span', {
    staticClass: "text-grey1"
  }, [_vm._v("Home > Looking For Doctor ")]), _vm.list && _vm.list.length ? _c('sections-slider', {
    attrs: {
      "list": _vm.list,
      "subTitle": "Health Care",
      "hasInnerBackground": true,
      "hasButton": false,
      "withSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemLogo": true,
            "product": listItem,
            "incrementDecrementKey": false,
            "marketRoute": {
              name: 'doctor-listing',
              params: {
                market: listItem.name,
                id: listItem._id,
                items: listItem.externalAttributes
              }
            }
          }
        })], 1)];
      }
    }], null, false, 3413402173)
  }) : _vm._e(), _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.recommendedStores,
      "subTitle": "Recommended Stores",
      "hasBackground": false,
      "showTitle": true,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Recommended Stores`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var listItem = _ref2.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('router-link', {
          staticStyle: {
            "text-decoration": "none",
            "color": "inherit"
          },
          attrs: {
            "to": {
              name: `shopDetails`,
              params: {
                id: listItem._id,
                items: listItem.office.officeName
              }
            }
          }
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemWhiteBg": true,
            "product": listItem
          }
        })], 1)], 1)];
      }
    }], null, false, 4030770339)
  }), _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.whatsTrending,
      "subTitle": "Whats Trending",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Whats Trending`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var listItem = _ref3.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 287040945)
  })], 1)], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }